import { FailedcustomerTagResponse } from "../../../constants/error_messages";
import { UPDATE_CUSTOMER_TAG } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { updateCustomerTagSuccess } from "../../api/customerTag";

const initialState = {
  Updateloading: false,
  customerTagList: [] as any,
  customrTagListConstant: [] as any,
  isUpdateCustomer: false,
  serchValue: "",
  responseError: {
    hasError: false,
    errorMessage: "",
  },
} as any;

const updateCustomerTagSlice = createSlice({
  name: UPDATE_CUSTOMER_TAG,
  initialState,
  reducers: {
    reset: () => {},
  },
  extraReducers: (builder) => {
    builder.addCase(updateCustomerTagSuccess.pending, (state) => {
      state.Updateloading = true;
    });
    builder.addCase(
      updateCustomerTagSuccess.fulfilled,
      (state, { payload }) => {
        if (payload?.data?.statusCode === 200) {
          // state.customerTagList = payload.data.customerTagList
          state.responseError.hasError = false;
        } else {
          state.responseError.hasError = true;
          state.responseError.errorMessage =
            payload?.message ?? FailedcustomerTagResponse;
        }
        state.Updateloading = false;
      }
    );
    builder.addCase(
      updateCustomerTagSuccess.rejected,
      (state, { payload }: any) => {
        state.responseError.hasError = true;
        state.responseError.errorMessage =
          payload?.message ?? FailedcustomerTagResponse;
        state.Updateloading = false;
      }
    );
  },
});
export const updateCustomerTagAction = updateCustomerTagSlice.actions;
export default updateCustomerTagSlice.reducer;
